<template>
	<div>
		<!-- 编辑对话框 -->
		<el-dialog
			:title="dialogType == 'add' ? '添加角色' : '编辑角色'"
			:visible.sync="isDialogVisible"
			:modal="false"
			:close-on-click-modal="false"
			:close-on-press-escape="true"
			:before-close="handleCloseDialog"
			width="612px"
		>
		<el-scrollbar style="height: 400px" ref="scrollbar">
			<el-form label-width="40px">
				<el-form-item label="名称"><el-input v-model="name"></el-input></el-form-item>
			</el-form>
			<el-transfer ref="transfer" :titles="['所有权限', '角色权限']" v-model="value" :data="allAuthority"></el-transfer>
			</el-scrollbar>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleCloseDialog">取 消</el-button>
				<el-button type="success" @click="handleDialogConfirm" :loading="loading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { GetRoleList } from '@/api/Role.js';
import { Add, UpdateRole } from '@/api/Role.js';
export default {
	name: 'Dialog',
	props: {
		/* 对话框是否可见 */
		isDialogVisible: {
			type: Boolean,
			default: false
		},
		/* 该用户的权限 */
		authority: {
			type: Array
		},
		/* 所有的权限 */
		allAuthority: {
			type: Array
		},
		/* 所有的权限 */
		authorityName: {
			type: String
		},
		/* 编辑权限的id */
		id: {
			type: Number
		},
		/* 弹窗类型 */
		dialogType: {
			type: String
		}
	},
	watch: {
		authority(val) {
			this.value = val;
		},
		authorityName(val) {
			this.name = val;
		}
	},
	data() {
		return {
			value: [],
			activeName: 'first',
			defalutValue: '', //选择的默认值
			defalutAuthorityList: [],
			name: '' ,//默认权限名称
			loading:false,
		};
	},
	mounted() {
		this.getDefList();
	},
	methods: {
		// 获取默认权限列表
		getDefList() {
			GetRoleList({ pageNumber: 1, pageSize: 10 }).then(res => {
				if (res.data.state == 1) {
					this.defalutAuthorityList = res.data.data.lis;
				}
			});
		},
		/* 对话框取消按钮事件 */
		handleCloseDialog() {
			this.$refs.transfer.$refs.leftPanel.checked = [];
			this.$refs.transfer.$refs.rightPanel.checked = [];
			this.name = '';
			this.$emit('close-dialog', false);
		},
		defalutAuthorityChange(e) {
			// console.log(e);
		},
		handleDialogConfirm() {
			if (this.name == '') {
				this.$message.warning('请填写角色名称');
				return;
			}
			this.loading = true
			let params = {
				roleName: this.name,
				rolePower: JSON.stringify(this.value),
				...(this.dialogType == 'edit' && { id: this.id })
			};
			if (this.dialogType == 'add') {
				Add(params).then(res => {
					if (res.data.state == 1) {
						this.loading = false
						this.$message.success('操作成功');
						this.$emit('dialog-confirm');
					} else {
						this.loading = false
						this.$message.error(res.msg);
					}
				});
			} else if (this.dialogType == 'edit') {
				UpdateRole(params).then(res => {
					if (res.data.state == 1) {
						this.loading = false
						this.$message.success('操作成功');
						this.$emit('dialog-confirm');
					} else {
						this.loading = false
						this.$message.error(res.msg);
					}
				});
			}
			this.$refs.transfer.$refs.leftPanel.checked = [];
			this.$refs.transfer.$refs.rightPanel.checked = [];
		},
		handleClick() {}
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #fff !important;
}
</style>
